import { render, staticRenderFns } from "./lunup.vue?vue&type=template&id=8fa3d590&scoped=true"
import script from "./lunup.vue?vue&type=script&lang=js"
export * from "./lunup.vue?vue&type=script&lang=js"
import style0 from "./lunup.vue?vue&type=style&index=0&id=8fa3d590&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa3d590",
  null
  
)

export default component.exports